<template>
  <div class="form-group">
    <b-form-group class="form-control form-control-lg text-center no-border" id="sel3">
      <b-form-radio-group v-model="question.GivenAnswer"
                          plain
                          class="w-100 d-flex justify-content-around p-t-20">
        <b-form-radio v-for="idx in [1,2,3,4,5]"
                      :key="idx"
                      class="material-icons"
                      :value="idx">
          <star-icon class="icon"
                     :class="{ active: question.GivenAnswer >= idx }"
                     decorative/>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
  import StarIcon from "vue-material-design-icons/Star"

  export default {
    props: {
      question: {
        required: true,
        type: Object,
      },
    },
    components: {StarIcon},
  }
</script>

<style scoped>
  .icon {
    color: lightgrey;
    transform: scale(3) translateX(-5px);
  }

  .active {
    color: darkblue;
  }

</style>



// WEBPACK FOOTER //
// src/components/surveys/types/Stars.vue